import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment as env } from 'src/environments/environment'
import { Institution } from '../../institution-page/interface/institution.interface';
import { TutorsZoomUrl } from '../interface/tutorsZoomUrl.interface';

@Injectable({
  providedIn: 'root',
})
export class UserRegistrationService {
  private baseUrl: string = env.apiUrl;

  constructor(private http: HttpClient) {}

  getRoles(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/role`);
  }

  addTutorZoomUrl(data: TutorsZoomUrl): Observable<TutorsZoomUrl> {
    return this.http.post<TutorsZoomUrl>(
      `${this.baseUrl}/tutors-zoom-url/register`,
      data
    );
  }
}
